import { Controller, useFormContext } from 'react-hook-form';
import { FormControl, FormHelperText, Grid, InputLabel, MenuItem, Select } from '@mui/material';
import type { CountryEntity } from '@shared/api';
import { CustomDatePicker } from '../CustomDatePicker';
import { Input, ValidateUtils } from '@shared';

interface IEmploymentProps {
  name: string;
  countries: CountryEntity[];
  economicActivities: string[];
}

export const Employment = (props: IEmploymentProps) => {
  const { control } = useFormContext();

  return (
    <>
      <Grid item xs={3}>
        <Controller
          name={`${props.name}.position`}
          control={control}
          rules={{ required: 'Position is required' }}
          render={({ field, fieldState: { error } }) => (
            <Input {...field} label='Position' margin='normal' required error={!!error} helperText={error?.message} />
          )}
        />
      </Grid>
      <Grid item xs={3}>
        <Controller
          name={`${props.name}.employer`}
          control={control}
          rules={{ required: 'Employer is required' }}
          render={({ field, fieldState: { error } }) => (
            <Input {...field} label='Employer' margin='normal' required error={!!error} helperText={error?.message} />
          )}
        />
      </Grid>
      <Grid item xs={3}>
        <Controller
          name={`${props.name}.country`}
          control={control}
          rules={{ required: 'Country is required' }}
          render={({ field, fieldState: { error } }) => (
            <>
              <FormControl margin='normal' fullWidth error={!!error}>
                <InputLabel>Country *</InputLabel>
                <Select {...field} variant='standard' fullWidth>
                  {props.countries.map((country, idx) => (
                    <MenuItem key={idx} value={country.name}>
                      {country.name}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{error?.message}</FormHelperText>
              </FormControl>
            </>
          )}
        />
      </Grid>
      <Grid item xs={3}>
        <Controller
          name={`${props.name}.date`}
          control={control}
          rules={{ required: 'Date is required', validate: { isValidDate: ValidateUtils.isValidDate } }}
          render={({ field, fieldState: { error } }) => (
            <CustomDatePicker {...field} label='Date' margin='normal' fullWidth required error={!!error} helperText={error?.message} />
          )}
        />
      </Grid>
      <Grid item xs={12}>
        <Controller
          name={`${props.name}.economicActivity`}
          control={control}
          rules={{ required: 'Economic activity is required' }}
          render={({ field, fieldState: { error } }) => (
            <>
              <FormControl margin='normal' fullWidth error={!!error}>
                <InputLabel>Economic activity *</InputLabel>
                <Select {...field} variant='standard' fullWidth>
                  {props.economicActivities.map((item, idx) => (
                    <MenuItem key={idx} value={item}>
                      {item}
                    </MenuItem>
                  ))}
                </Select>
                <FormHelperText>{error?.message}</FormHelperText>
              </FormControl>
            </>
          )}
        />
      </Grid>
    </>
  );
};
